import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Cursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [clicking, setClicking] = useState(false);

  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const down = () => setClicking(true);
    const up = () => setClicking(false);
    window.addEventListener("mousemove", move);
    window.addEventListener("mousedown", down);
    window.addEventListener("mouseup", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mousedown", down);
      window.removeEventListener("mouseup", up);
    };
  }, []);

  useEffect(() => {
    const targets = document.querySelectorAll("a, button, [data-cursor]");
    const enter = () => setHovering(true);
    const leave = () => setHovering(false);
    targets.forEach((el) => {
      el.addEventListener("mouseenter", enter);
      el.addEventListener("mouseleave", leave);
    });
    return () => {
      targets.forEach((el) => {
        el.removeEventListener("mouseenter", enter);
        el.removeEventListener("mouseleave", leave);
      });
    };
  });

  return (
    <>
      {/* Dot */}
      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          zIndex: 9999,
          mixBlendMode: "difference",
        }}
        animate={{
          x: pos.x - (hovering ? 20 : 5),
          y: pos.y - (hovering ? 20 : 5),
          width: hovering ? 40 : 10,
          height: hovering ? 40 : 10,
          backgroundColor: hovering ? "#fff" : "#39ff14",
          borderRadius: "50%",
          scale: clicking ? 0.8 : 1,
        }}
        transition={{ type: "spring", stiffness: 500, damping: 28, mass: 0.3 }}
      />
      {/* Ring */}
      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          zIndex: 9998,
          borderRadius: "50%",
          border: `1px solid ${hovering ? "#00d4ff" : "rgba(57,255,20,0.4)"}`,
        }}
        animate={{
          x: pos.x - 18,
          y: pos.y - 18,
          width: 36,
          height: 36,
          opacity: hovering ? 0.8 : 0.5,
          scale: clicking ? 0.9 : 1,
        }}
        transition={{ type: "spring", stiffness: 200, damping: 20, mass: 0.5 }}
      />
    </>
  );
}
